import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LoanAppPageService } from '../../../../core/services/page-services/loan-app-page.service';
import { LgvPricingService } from '../../services/pricing.service';
import { BehaviorSubject, mergeMap, takeUntil } from 'rxjs';

@Component({
    selector: 'lgv-client-pricing-quotes',
    templateUrl: './client-pricing-quotes.component.html',
    styleUrls: ['./client-pricing-quotes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientPricingQuotesComponent implements OnInit {
    constructor(public loanAppPageSvc: LoanAppPageService) {}

    ngOnInit(): void {}
}
